<template>
  <video v-if="fileUrl && thumbnail" :src="fileUrl" class="video-tag" width="100%" playsinline muted
    :autoplay="getOS() == 'iOS' ? false : true" controls controlsList="nodownload noremoteplayback" :poster="thumbnail">
    Invalid video
  </video>
</template>

<script>
import Api2 from "@/services/Api2";
import Api from "@/services/Api";
import AWSUrlApi from "@/services/AWSUrlApi";

export default {
  props: ["video"],
  data() {
    return {
      fileUrl: null,
      thumbnail: null
    };
  },
  methods: {
    async getThumbnailUrl() {
      if (this.video) {
        if (this.video.thumbnail) {
          //userFile(video.thumbnail)
          if (this.video.thumbnail.indexOf('storage-bjjlink-core-prod') >= 0 || this.video.thumbnail.indexOf('bjjlink-elevate-storage') >= 0) {
            this.thumbnail = this.video.thumbnail;
            return;
          }
          if (this.video.thumbnail.indexOf('media/') >= 0) {
            Api2()
              .get(this.video.thumbnail)
              .then((res) => {
                this.thumbnail = res.data;
              });
          } else {
            const encodedUrl = encodeURIComponent(this.video.thumbnail)
            Api2()
              .get("content/url/signed/" + encodedUrl)
              .then(res => {
                this.thumbnail = res.data;
              })
          }
        } else {
          this.thumbnail = '/static/play_background.png';
        }
      }
    },
    getFileUrl() {//media
      if (this.video && this.video.fileUrl) {
        const fileUrl = this.video.fileUrl;
        if (fileUrl.indexOf('media/') >= 0) {
          //Now that we are ging through the /api version of the routes, we need to strip out the media
          AWSUrlApi()
            .get(fileUrl.replace('media/', ''))
            .then((res) => {
              this.fileUrl = res.data;
            });
        } else {
          const encodedUrl = encodeURIComponent(fileUrl)
          Api()
            .get("content/url/signed/" + encodedUrl)
            .then(res => {
              this.fileUrl = res.data;
            })
        }
      }
    },
  },
  created() {
    this.getFileUrl();
    this.getThumbnailUrl();
  },
};
</script>

<style scoped>
.video-tag {
  border-top: 1px solid #f8f8f8;
  border-bottom: 1px solid #f8f8f8;
}
</style>